import React from "react";
import ShippingAddressDTO from "@/dto/ShippingAddressDTO";
import { observer } from "mobx-react-lite";
import MultiPlatformEwaybillResultStore from "./MultiPlatformEwaybillResultStore";
import { platforms } from "../MultiPlatformPrintWaybillModal";
import EwaybillPrintInfo from "./EwaybillPrintInfo";
import EwaybillResultStore from "@/scenes/OrderManagement/components/dialogs/PrintEwaybillResultDialog/EwaybillResultStore";

function buildSelectOptionContent(shippingAddress: ShippingAddressDTO) {
    const parts: string[] = [];

    if (shippingAddress.name) {
        parts.push(shippingAddress.name, "-");
    }

    if (shippingAddress.shipperName) {
        parts.push(shippingAddress.shipperName, "，");
    }

    parts.push(shippingAddress.province, shippingAddress.city, shippingAddress.district);

    if (shippingAddress.street) {
        parts.push(shippingAddress.street, "，");
    }

    parts.push(shippingAddress.mobile, shippingAddress.telephone);

    return parts.join("");
}

interface EwaybillResultAlertProps {
    store: MultiPlatformEwaybillResultStore;

    printerName: string;
}

const EwaybillResultAlert: React.FC<EwaybillResultAlertProps> = function (props) {
    const { store, printerName } = props;

    let ewaybillResultStores: EwaybillResultStore[] = [];

    if (printerName) {
        const stores = store.platformStoresMapping.get(printerName);

        if (stores?.length) {
            ewaybillResultStores.push(...stores);
        }
    } else {
        platforms.forEach((platform) => {
            if (store[platform]) {
                ewaybillResultStores.push(store[platform]);
            }
        });
    }

    let copies: string | number;

    if (store.useMaxQuantityPerPackage) {
        copies = "自动分包";
    } else {
        copies = store.copies;
    }

    return (
        <div className="mb10">
            {ewaybillResultStores?.map((ewaybillResultStore) => {
                const platform = platforms.find((platform) => store[platform] === ewaybillResultStore);

                return (
                    <EwaybillPrintInfo key={platform} platform={platform} store={ewaybillResultStore} copies={copies} />
                );
            })}

            <p>
                <span>发货人:</span>
                <span data-openreplay-masked>{buildSelectOptionContent(store.shippingAddress)}</span>
            </p>
        </div>
    );
};

export default observer(EwaybillResultAlert);
